{
	"completed": {
		"description": "L'export è pronto. Il download dovrebbe avviarsi automaticamente.",
		"title": "Export pronto"
	},
	"details": {
		"expires_at": "Scade il",
		"format": "Formato",
		"rows": "Righe",
		"unknown": "Sconosciuto"
	},
	"dialog": {
		"button": "Esporta",
		"downloaded": "Download avviato.",
		"format": {
			"csv": "CSV",
			"xlsx": "XLSX"
		},
		"started": "Export in coda. Lo riceverai via email quando sarà pronto."
	},
	"download_again": "Scarica di nuovo",
	"error": {
		"title": "Export non disponibile"
	},
	"expired": {
		"description": "Questo export non è più disponibile.",
		"title": "Export scaduto"
	},
	"failed": {
		"description": "Non è stato possibile generare l'export.",
		"title": "Export non riuscito"
	},
	"loading": "Caricamento export...",
	"manager": {
		"description": "I file da consegnare agli enti che controllano i bandi. Ogni download viene registrato, perché contiene i dati degli studenti.",
		"page_title": "Esporta",
		"ranking_in_force": "Versione in vigore della graduatoria",
		"ranking_none": "Nessuna graduatoria finché il bando non apre",
		"ranking_provisional": "Graduatoria provvisoria, calcolata ora",
		"ranking_title": "Graduatoria (CSV o XLSX)"
	},
	"page_title": "Esporta",
	"refresh": "Aggiorna",
	"status": {
		"completed": "Completato",
		"expired": "Scaduto",
		"failed": "Non riuscito",
		"pending": "In attesa",
		"running": "In corso"
	},
	"waiting": {
		"description": "L'export è ancora in preparazione.",
		"title": "Export in corso"
	}
}
